export default __webpack_public_path__ + "static/media/logo-thobe-events.e17c1d1c.png";